import { useEffect, useState } from 'react';

const useDeleteTalentFromPool = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const deleteTalentFromPool = async (talentId) => {
    setIsLoading(true);
    try { 
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/talent-pool/${talentId}`, {
        method: 'DELETE',
        credentials: 'include', 
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setSuccessMessage(data.message);
    } catch (error) {
      setError(error.message);
    }
    setIsLoading(false);
  };

  return { isLoading, error, successMessage, deleteTalentFromPool };
};

export default useDeleteTalentFromPool;
